export const SHRUG = '¯\\_(ツ)_/¯';
export const PRO_PREFIX = 'pro';
export const GOOGLE_CLIENT_ID = 
'246438887397-bf4i9cejmubkgq9n3qj8omsh8f88u0s8.apps.googleusercontent.com';
